import {
  FEEDBACK_TYPES,
  IDENTITY_MODES,
  MAX_BODY_LENGTH,
  MAX_DISPLAY_NAME_LENGTH,
  MAX_GUEST_USERNAME_LENGTH,
  RATING_CATEGORIES,
} from './constants';
import { getTopicLabel } from './topics';

export function getFeedbackPageTitle(feedbackType) {
  if (feedbackType === FEEDBACK_TYPES.SESSION) {
    return 'SESSION FEEDBACK';
  }
  if (feedbackType === FEEDBACK_TYPES.TOPIC) {
    return 'TOPIC FEEDBACK';
  }
  return 'FEEDBACK';
}

export function getFeedbackIntro(feedbackType, topicId = null) {
  if (feedbackType === FEEDBACK_TYPES.SESSION) {
    return 'Rate your session and share optional comments. Your feedback helps us improve Black Box VR.';
  }
  if (feedbackType === FEEDBACK_TYPES.TOPIC && topicId) {
    return `Share feedback about ${getTopicLabel(topicId)}. We read every submission.`;
  }
  return 'Share your thoughts with the Black Box VR team. We read every submission.';
}

export function extractFeedbackErrorMessage(error) {
  if (typeof error === 'string' && error) {
    return error;
  }
  if (typeof error?.data?.errorMessage === 'string' && error.data.errorMessage) {
    return error.data.errorMessage;
  }
  if (typeof error?.data?.error === 'string' && error.data.error) {
    return error.data.error;
  }
  if (typeof error?.data === 'string' && error.data) {
    return error.data;
  }
  if (typeof error?.errorMessage === 'string' && error.errorMessage) {
    return error.errorMessage;
  }
  if (typeof error?.message === 'string' && error.message) {
    return error.message;
  }
  return 'Submit failed! Please try again later.';
}

export function createEmptyRatings() {
  return {
    game: null,
    machine: null,
    heroTrainer: null,
  };
}

export function createEmptyTexts() {
  return {
    game: '',
    machine: '',
    heroTrainer: '',
  };
}

export function buildFeedbackPayload({
  feedbackType,
  identityMode,
  user,
  username,
  guestUsername,
  displayName,
  body,
  ratings,
  texts,
  topicId,
  sessionId,
  isAnonymous,
  pageUrl,
}) {
  const payload = {
    action: 'createFeedback',
    feedbackType,
    isAnonymous,
    metadata: pageUrl ? { pageUrl } : {},
  };

  if (identityMode === IDENTITY_MODES.ACCOUNT && user?.userId) {
    payload.userId = user.userId;
  }

  if (identityMode === IDENTITY_MODES.USERNAME) {
    payload.usernameOrEmail = guestUsername.trim().slice(0, MAX_GUEST_USERNAME_LENGTH);
  }

  if (feedbackType === FEEDBACK_TYPES.TOPIC && topicId) {
    payload.topicId = topicId;
  }

  if (feedbackType === FEEDBACK_TYPES.SESSION && sessionId) {
    payload.sessionId = sessionId;

    const ratingsPayload = {};
    RATING_CATEGORIES.forEach(({ key }) => {
      if (ratings[key] != null && ratings[key] > 0) {
        ratingsPayload[key] = ratings[key];
      }
    });
    payload.ratings = ratingsPayload;

    const textsPayload = {};
    RATING_CATEGORIES.forEach(({ key }) => {
      const value = texts[key]?.trim();
      if (value) {
        textsPayload[key] = value.slice(0, MAX_BODY_LENGTH);
      }
    });
    if (Object.keys(textsPayload).length > 0) {
      payload.texts = textsPayload;
    }
  } else {
    payload.texts = { body: body.trim().slice(0, MAX_BODY_LENGTH) };
  }

  if (!isAnonymous) {
    const fallbackName =
      identityMode === IDENTITY_MODES.ACCOUNT ? username : guestUsername.trim();
    const name = (displayName.trim() || fallbackName).slice(0, MAX_DISPLAY_NAME_LENGTH);
    if (name) {
      payload.displayName = name;
    }
  }

  return payload;
}
